import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import { useFetchEmailTemplateQuery } from 'actions/emailTemplates';
import { useFetchUserProfile } from 'actions/userProfile';
import config from 'utils/config';
export function useFetchFormattedShareTemplate() {
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data,
    isUserProfileLoading = _useFetchUserProfile.isLoading;
  var _useFetchEmailTemplat = useFetchEmailTemplateQuery({
      emailTemplate: 'recommendation'
    }),
    shareEmailTemplate = _useFetchEmailTemplat.data,
    isShareTemplateLoading = _useFetchEmailTemplat.isLoading;
  var isLoading = isShareTemplateLoading || isUserProfileLoading;
  if (!shareEmailTemplate || !userProfile || isLoading) {
    return {
      shareTemplate: undefined,
      isLoading: isLoading
    };
  }
  var body = shareEmailTemplate.body,
    subject = shareEmailTemplate.subject;
  var pageTitle = config.pageTitle;
  var authorDisplayName = userProfile.displayName;
  var authorEmail = userProfile.email;
  function replaceTemplateTags(template) {
    return template.replaceAll('{{domain.pageTitle}}', pageTitle).replaceAll('{{author.displayName}}', authorDisplayName).replaceAll('{{author.email}}', authorEmail).replaceAll('{{domain.origin}}', window.location.origin);
  }
  return {
    shareTemplate: {
      message: replaceTemplateTags(body),
      subject: replaceTemplateTags(subject)
    },
    isLoading: isLoading
  };
}
export default useFetchFormattedShareTemplate;